import {ApiError, errorMessage} from '../../api/client';

// A .problem box from any thrown value, with an optional Retry.
export default function ErrorBox({error, onRetry, className = ''}: {error: unknown; onRetry?: () => void; className?: string}) {
    if (!error) return null;
    return (
        <div role="alert" className={`problem flex items-center gap-3 ${className}`}>
            <span className="min-w-0 flex-1">{errorMessage(error)}</span>
            {onRetry && (
                <button type="button" className="shrink-0 rounded-sm px-2 py-1 font-display font-bold underline-offset-2 hover:underline" onClick={onRetry}>
                    Try again
                </button>
            )}
        </div>
    );
}

/** The server's message for one field (ApiError.key), or nothing. */
export function FieldError({error, field}: {error: unknown; field: string}) {
    if (!(error instanceof ApiError) || error.key !== field) return null;
    return (
        <p role="alert" className="m-0 text-xs font-semibold text-rust">
            {error.message}
        </p>
    );
}

/** True when the error belongs to no particular field, so the form shows it at the bottom. */
export const isGeneralError = (error: unknown): boolean => !!error && !(error instanceof ApiError && error.key);
